import { Badge } from "@/components/ui/Badge";
import { Show } from "solid-js";
import { ActionDropdown, ActionDropdownMenuItemLink } from "../../components/ui/actions/ActionDropdown";

export const getCaseColumns = ({ onListAction }) => {

  const onAction = (action, key) => {
  }

  return [
    {
      title: 'Patient',
      key: 'patient',
      sort: true,
      render: (row) => row.patient
    },
    {
      title: 'Start Date',
      key: 'startDate',
      render: (row) => row.startDate
    },
    {
      title: 'Status',
      key: 'status',
      render: (row) => {
        return <Badge variant={row.status === 'Active' ? 'success' : 'warning'}>{row.status}</Badge>
      }
    },
    {
      title: '',
      isPlaceholder: true,
      key: null,
      render: (row) => {
        return (
          <div class="flex gap-2 items-center">
            <ActionDropdown asIcon>
              <ActionDropdownMenuItemLink icon="carbon:prompt-session" href={`/case/${row.key}/appointments`}>Appointments</ActionDropdownMenuItemLink>
            </ActionDropdown>
          </div>
        );
      }
    }
  ];
}
